module.exports = __webpack_public_path__ + "static/img/1-1Z603162U2926.75a60fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z603162U2926.jpg
// module id = TanQ
// module chunks = 0